$(document).ready(function () {
    var $trainTimes = $('[data-train-times]');
    if ($trainTimes.length > 0) {
        if ($('#showArrivalsVal').val() === 'true') {
            $trainTimes.find('ul.flight-tabs li').removeClass('current');
            $trainTimes.find('.flight-tab--content').removeClass('current');
            $trainTimes.find('*[data-tab="arrivals"]').addClass('current');
            $trainTimes.find('#arrivals').addClass('current');
        }
        
        $trainTimes.find('.train-details--expanded').hide();
        
        $trainTimes.find('.train-details').on('click', function () {
            var $this = $(this);
            $this.toggleClass('expanded');
            $this.find('.fa-angle-down, .fa-angle-up').toggleClass('fa-angle-down fa-angle-up');
            $this.find('.train-details--expanded').slideToggle();
        });

        $trainTimes.find('.flight-tab--link').on('click', function () {
            var $this = $(this);
            var dataTab = $this.attr('data-tab');
            $trainTimes.find('.flight-tab--link').not(this).removeClass('current');
            $this.addClass('current');
            $trainTimes.find('.flight-tab--content').removeClass('current');
            $trainTimes.find('#' + dataTab).addClass('current');
        });
    }
});